<script setup>
// Marqueur de la bible : le fond se dessine de gauche à droite derrière le texte (0,5 s),
// puis le texte prend sa couleur de contraste. Utilisé sur le prénom du compte et le mot-clé des H1.
import { onMounted, ref } from 'vue';
import { TONES } from '../../lib/brandTones';

const props = defineProps({
  tone: { type: String, default: 'maison' },
  delay: { type: Number, default: 150 },
});
const on = ref(false);
onMounted(() => { setTimeout(() => { on.value = true; }, props.delay); });
</script>

<template>
  <span class="hl-draw" :class="{ on }" :style="{ '--hl-bg': TONES[tone].markBg, '--hl-text': TONES[tone].markText }"><slot /></span>
</template>
